import { useMemo, useState } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import {
  FormatDateTime,
  FormatStartDateTime,
} from "../../../../../utils/functions/ResourceFunctions";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { useGetPendingLineManagerAppraisalsQuery } from "../../../../api/employeeApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import Pagination from "../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { getPeriodDateRange } from "../../HR/HrAppraisal";
const LineManagerProcesses = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [period, setPeriod] = useState(1);
  const { start, end } = useMemo(() => getPeriodDateRange(period), [period]);
  const navigate = useNavigate();
  const user = GetLocalStorage();
  const {
    searchText,
    setSearchText,
    filter,
    setFilter,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const handleView = (id, referenceId) => {
    if (id) {
      navigate(`${id}/view/${referenceId}`);
    }
  };
  const { data, isLoading } = useGetPendingLineManagerAppraisalsQuery({
    LineManagerId: user.staffId,
    PageNumber: currentPage,
    PageSize: pageSize,
    SearchTerm: searchText,
    PeriodStartDate: start,
    PeriodEndDate: end,
    Status: filter,
    StartDate: startDate,
    EndDate: endDate,
  });
  
  const sortedData = useMemo(() => {
    if (!data?.responseObject?.pageItems) return [];
    return [...data.responseObject.pageItems].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      // For strings, make case-insensitive
      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [data?.responseObject?.pageItems, sortColumn, sortDirection]);

  const filterBy = [
    {
      name: "Draft",
      filter: 0,
    },
    {
      name: "Awaiting LineManager",
      filter: 1,
    },
    {
      name: "Awaiting Peer Review",
      filter: 2,
    },
    {
      name: "Awaiting Upward Review",
      filter: 3,
    },
    {
      name: "Awaiting Cross Review",
      filter: 4,
    },
    {
      name: "Awaiting HOD",
      filter: 5,
    },
    {
      name: "Awaiting HR",
      filter: 6,
    },
    {
      name: "Completed",
      filter: 7,
    },
    {
      name: "Awaiting ED",
      filter: 8,
    },
    {
      name: "Awaiting MD",
      filter: 9,
    },
  ];
  const periodFilter = [
    { name: "Daily", filter: 1 },
    { name: "Weekly", filter: 2 },
    { name: "Monthly", filter: 3 },
    { name: "QUarterly", filter: 4 },
    { name: "BiAnnual", filter: 5 },
    { name: "Yearly", filter: 6 },
  ];
  return (
    <PageStyle
      hasBack={false}
      demoTitle={"Line Manager Processes"}
      hasTopPageDemo
    >
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Appraisal Workflow Status"}
          filterBy={filterBy}
        />
        <ProDropFilter
          filter={period}
          setFilter={(value) => setPeriod(Number(value))}
          name={"Period"}
          filterBy={periodFilter}
        />
      </form>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>S/N</th>
              <th style={{ cursor: "pointer" }}>Appraise Name</th>
              <th style={{ cursor: "pointer" }}>Department</th>
              <th style={{ cursor: "pointer" }}>Job Title</th>
              <th style={{ cursor: "pointer" }}>Appraisal Period</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={6} className="text-center">
                  Loading...
                </td>
              </tr>
            )}
            {sortedData?.length > 0 &&
              sortedData?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.appraiseeName}</td>
                  <td>{item?.department}</td>
                  <td>{item?.jobTitle}</td>
                  <td>{item?.appraisalPeriodDisplay}</td>
                  <td>
                    <TableActions
                      hasChildren={true}
                      url={`${item.appraisalPeriodId}/view/${item.referenceId}`}
                    >
                      {[
                        {
                          name: "View",
                          action: () => handleView(item.appraisalPeriodId, item.referenceId),
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))}
            {sortedData?.length === 0 && !isLoading && (
              <tr>
                <td colSpan={6} className="text-center">
                  No Appraisal Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        last_page={data?.responseObject?.totalNumberOfPages}
        present_page={data?.responseObject?.currentPage}
        totalRows={data?.responseObject?.totalCount}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
    </PageStyle>
  );
};

export default LineManagerProcesses;
